import React, { useEffect } from 'react';
import { DrawerBody, DrawerFooter, DrawerHeader, DrawerHeaderNavigation, DrawerHeaderTitle, makeStyles, OverlayDrawer, Toolbar, ToolbarButton, ToolbarGroup } from '@fluentui/react-components';
import { DefaultButton } from '@fluentui/react';
import { connect } from 'react-redux';
import { Dismiss24Regular } from '@fluentui/react-icons';

// component functions
import * as ComponentFunctions from './StageFix.Form.Functions';

// models
import { ContractStage } from '../../../../models/Entities/Contracts/ContractStage';

// components
import StageFixFormItemComponent from './StageFixFormItem/StageFix.Form.Item.Component';

const StageFixFormComponent = (props: ComponentFunctions.Props) => {

    const styles = useStyles();

    //load necesary data
    useEffect(() => {
        props.Protocol?.id && props.GetMedicalProtocolById(props.Protocol?.id);
    }, [props.Protocol?.id === undefined]);

    // save control
    useEffect(() => {
        props.GetVisitFullByProtocolId(props.ProtocolId);
    }, [props.Protocol?.id !== undefined]);

    const HandleCancelForm = () => {
        props.dismissPanel();
    };

    // footer
    const onRenderFooterContent = () => {
        return (
            <div className={styles.footer}>
                <DefaultButton onClick={HandleCancelForm} className="OtherOption">
                    Cerrar
                </DefaultButton>
            </div>
        );
    };

    const formFields = props.Stages?.map((stage: ContractStage, index: number) =>
        <StageFixFormItemComponent ProtocolId={props.ProtocolId} StageId={stage.id} />
    );

    return (
        <OverlayDrawer open={props.isOpen} position={"end"} size='small'>
            <DrawerHeader>
                <DrawerHeaderNavigation>
                    <Toolbar className={styles.toolbar}>
                        <ToolbarGroup>
                            <ToolbarButton
                                aria-label="Close panel"
                                appearance="subtle"
                                icon={<Dismiss24Regular />}
                                onClick={HandleCancelForm}
                            />
                        </ToolbarGroup>
                    </Toolbar>
                </DrawerHeaderNavigation>
                <DrawerHeaderTitle>Visitas Protocolares {props.Stages?.length}</DrawerHeaderTitle>
            </DrawerHeader>
            <DrawerBody>
                <div className={styles.body}>
                    {formFields}
                </div>
            </DrawerBody>
            <DrawerFooter>
                {onRenderFooterContent}
            </DrawerFooter>

        </OverlayDrawer >
    );
};

export default connect (
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
) (StageFixFormComponent as any);


const buttonStyles = { root: { marginRight: 8, class: 'ConfirmAction' } };

const useStyles = makeStyles({
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
    },
  
    body: {
      flex: "1",
      width: "100%",
      maxWidth: "100%",
      position: "relative",
    },

  
    footer: {
        display: "flex",
        justifyContent: "space-between",
        padding: "0 16px 16px 16px",
    },
  });